'use client';

import type { SpecialitySuggestion } from '../types';
import {
  ResultColumnEmpty,
  ResultColumnHeader,
  resultRowClassName,
} from './resultColumnShared';

interface SpecialitiesColumnProps {
  items: { item: SpecialitySuggestion; flatIndex: number }[];
  activeIndex: number;
  hoveredSpecialitySlug: string | null;
  onHover: (slug: string, flatIndex: number) => void;
  onClearHover: () => void;
  onSelect: (url: string) => void;
}

/** Left column: speciality page matches. Hovering narrows the doctors column. */
export default function SpecialitiesColumn({
  items,
  activeIndex,
  hoveredSpecialitySlug,
  onHover,
  onClearHover,
  onSelect,
}: SpecialitiesColumnProps) {
  return (
    <div className="md:max-h-searchbar-column-max-height flex min-h-0 min-w-0 flex-col overflow-y-auto">
      <ResultColumnHeader title="Specialities" count={items.length} />
      <div className="flex flex-col gap-1 p-1" onMouseLeave={onClearHover}>
        {items.length === 0 ? (
          <ResultColumnEmpty>No specialities found</ResultColumnEmpty>
        ) : (
          items.map(({ item, flatIndex }) => {
            const isActive =
              flatIndex === activeIndex || hoveredSpecialitySlug === item.slug;
            return (
              <button
                key={`${item.type}-${item.slug}`}
                id={`option-${item.type}-${encodeURIComponent(item.slug)}`}
                role="option"
                aria-selected={isActive}
                type="button"
                onMouseEnter={() => onHover(item.slug, flatIndex)}
                onClick={() => onSelect(item.url)}
                className={`flex items-center justify-between ${resultRowClassName(isActive)} ${
                  isActive ? 'ring-1 ring-slate-200' : ''
                }`}
              >
                <div className="flex flex-col">
                  <span className="font-bold text-slate-800">{item.title}</span>
                  <span className="text-caption mt-0.5 text-slate-400">
                    View Speciality Page
                  </span>
                </div>
                <span className="text-theme-action-primary bg-theme-action-primary/10 text-caption ml-4 shrink-0 rounded-full px-2 py-0.5 font-bold">
                  Speciality
                </span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
